module.exports = __webpack_public_path__ + "static/learningCatGif-590f7a4d7f1822c0f80039d5ad306db5.gif";